export const url = 'https://service.elegantenterprisesinc.com/crm/api/';
export const hosting = 'https://service.elegantenterprisesinc.com';

export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
export const isMobile = (/Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent));

export function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/; samesite=strict;__Secure-";
}
export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
export function showElement(className){
  if ($('.'+className).is(':visible')) {
    $('.'+className).hide();
  }else{$('.'+className).show();}
}
export function timeToAmPm(time){
  if (time !== null){
    let temp = time.split(':');
    if (temp.length === 3){
      if (parseInt(temp[0])>12){
        temp[0] = parseInt(temp[0]) - 12;
        if (temp[0]<10){temp[0] = '0' + temp[0]}
        temp[1] =  temp[1] + ' pm';
      }
      else{temp[1] =  temp[1] + ' am';}
      time = temp[0] + ':' + temp[1] ;
    }
  }else{time = "not finished"}
  return time;
}
